export default function About() {
  const capabilities = [
    {
      icon: 'ri-building-2-line',
      title: 'Project Development Company',
      description: 'Designing and delivering circular infrastructure projects from concept through construction',
      color: 'emerald'
    },
    {
      icon: 'ri-funds-line',
      title: 'Venture Capital Platform',
      description: 'Investing in early-stage circular economy technologies and innovations',
      color: 'amber'
    },
    {
      icon: 'ri-lightbulb-line',
      title: 'Innovation Venture Builder',
      description: 'Creating scalable climate infrastructure businesses that drive systemic change',
      color: 'blue'
    }
  ];

  const expertise = [
    'Renewable energy development',
    'Water and wastewater management',
    'Circular economy systems',
    'Blended finance and climate investment'
  ];

  return (
    <section id="about" className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <div className="inline-block bg-emerald-100 text-emerald-700 px-4 py-2 rounded-full text-sm font-semibold mb-6">
            Who We Are
          </div>
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
            A Hybrid Organization with <strong>Three Powerful Capabilities</strong>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Kagesi Development combines project development, venture capital, and innovation building to transform underutilized waste streams into new infrastructure assets that generate energy, produce fertiliser, and recover water.
          </p>
        </div>

        <div className="grid lg:grid-cols-3 gap-8 mb-16">
          {capabilities.map((capability, index) => (
            <div key={index} className="bg-white p-8 rounded-2xl border border-gray-200 hover:shadow-xl transition-all">
              <div className={`w-14 h-14 bg-${capability.color}-100 rounded-xl flex items-center justify-center mb-6`}>
                <i className={`${capability.icon} text-${capability.color}-600 text-2xl`}></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">{capability.title}</h3>
              <p className="text-gray-600 leading-relaxed">{capability.description}</p>
            </div>
          ))}
        </div>

        <div className="bg-white p-10 rounded-2xl border border-gray-200">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div>
              <h3 className="text-2xl font-bold text-gray-900 mb-6">
                Multidisciplinary Expertise
              </h3>
              <p className="text-gray-600 mb-6 leading-relaxed">
                Our team brings together deep expertise across multiple domains, allowing us to develop projects that deliver both strong commercial returns and measurable environmental impact.
              </p>
              <div className="space-y-3">
                {expertise.map((item, index) => (
                  <div key={index} className="flex items-center gap-3">
                    <div className="w-6 h-6 bg-emerald-100 rounded-full flex items-center justify-center flex-shrink-0">
                      <i className="ri-check-line text-emerald-600 text-sm"></i>
                    </div>
                    <span className="text-gray-700 font-medium">{item}</span>
                  </div>
                ))}
              </div>
            </div>
            <div className="relative h-80 rounded-xl overflow-hidden">
              <img 
                src="https://public.readdy.ai/ai/img_res/20928b6d86bd2361919a2e943e907159.jpg"
                alt="Kagesi Development Team"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}